import { render, staticRenderFns } from "./PowerCompanyEdit.vue?vue&type=template&id=9896b2ec&scoped=true"
import script from "./PowerCompanyEdit.vue?vue&type=script&lang=js"
export * from "./PowerCompanyEdit.vue?vue&type=script&lang=js"
import style0 from "./PowerCompanyEdit.vue?vue&type=style&index=0&id=9896b2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9896b2ec",
  null
  
)

export default component.exports